enum Removable {
  LIST = "list",
  TASK = "task",
  MILESTONE = "milestone",
  PROJECT = "project",
  RESSOURCE = "ressource",
  EVENT = "event",
}

export { Removable };
